import {TableSettings} from "../../../../tableSettings";

export const amsUserPortTable:TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Code',
      accessor: 'code',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.78,
    },
    {
      Header: 'Port Name',
      accessor: 'portName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 56.52,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.70,
    },
  ]
};

export const amsUserScacTable:TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Code',
      accessor: 'code',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.78,
    },
    {
      Header: 'SCAC Name',
      accessor: 'scacName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 56.52,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.70,
    },
  ]
};